var map = {
	"./ic-deals-active.svg": 913,
	"./ic-departments-active.svg": 7281,
	"./ic-favorites-active.svg": 143,
	"./ic-featured-active.svg": 2670,
	"./ic-home-active.svg": 4431,
	"./ic-menu-active.svg": 5347,
	"./ic-popular-active.svg": 3135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;